import styled from 'styled-components'

interface IButtonProps {
  disabled?: boolean
}

export const Button = styled.button<IButtonProps>`
  width: 116px;
  height: 40px;
  background: ${({ disabled, theme }) => (disabled ? theme.colors.colorb9c2ce : theme.colors.color378ff7)} 0% 0%
    no-repeat padding-box;
  border: none;
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  span:first-child {
    display: flex;
    column-gap: 8px;
    justify-content: center;
    align-items: center;
  }

  svg {
    fill: ${({ theme }) => theme.zds.colors.neutral1000};
    width: 24px;
    height: 24px;
  }
`

export const Label = styled.span`
  font: normal normal medium 14px/21px Inter;
  color: ${({ theme }) => theme.zds.colors.neutral1000};
`
